import React, { type ReactNode } from 'react'

import { Button, Icon, Loader, ModalBox, useMediaQueryContext } from '@fourthwall/components'
import { SecureBadgeIcon } from '@fourthwall/icons'
import { SelectPaymentMethod } from '@modules/Dashboard/modules/PaymentMethods'

import * as S from './PaymentMethodRequiredModal.styled'

export type PaymentMethodRequiredModalViewProps = {
  title: string
  subtitle?: ReactNode
  submitLabel: string
  withChargeLimit: boolean
  onSuccess: () => void
  onClose: () => void
  onAddPaymentMethodClose: () => void
}

export const PaymentMethodRequiredModalView = ({
  title,
  subtitle,
  submitLabel,
  withChargeLimit,
  onSuccess,
  onClose,
  onAddPaymentMethodClose,
}: PaymentMethodRequiredModalViewProps) => {
  const media = useMediaQueryContext()

  const renderSubtitle = (isLoading: boolean) => {
    if (!subtitle || isLoading) {
      return null
    }

    return <S.Subtitle>{subtitle}</S.Subtitle>
  }

  return (
    <SelectPaymentMethod
      submitLabel={submitLabel}
      withChargeLimit={withChargeLimit}
      onSuccess={onSuccess}
      onAddPaymentMethodClose={onAddPaymentMethodClose}
    >
      {({ renderContent, renderSubmitButton, isLoading }) => (
        <ModalBox
          title={title}
          buttons={[
            <Button label="Cancel" appearance="secondary" onClick={onClose} />,
            renderSubmitButton({ fullWidth: !media.tablet }),
          ]}
          footer={<Icon component={SecureBadgeIcon} height={20} />}
          onClose={onClose}
        >
          {isLoading && (
            <S.LoaderWrapper>
              <Loader size="large" />
            </S.LoaderWrapper>
          )}

          {renderSubtitle(isLoading)}

          {renderContent()}
        </ModalBox>
      )}
    </SelectPaymentMethod>
  )
}
